import React from 'react';
import { Icon } from '../Icon';
import tabletMemoirSrc from '../../assets/images/slide/product-tablet-memoir.png';
import styles from './ProductSlideContentV8.css';

const STEP_OPTIONS = [
    {
        icon: 'pencil',
        title: 'We ask one question',
        subtitle: 'then follow up on what you said'
    },
    {
        icon: 'mic',
        title: 'You answer your way',
        subtitle: 'out loud or by typing'
    }
];

const STORY_BULLETS = ['you talk it through', 'we write it down', 'you change anything'];

function ProductSlideContentV8({
    description = 'Some are recording for a grandchild. Some just so it exists somewhere other than their own head. Talk or type. We do the rest.'
}) {
    return (
        <div className={styles.form}>
            <div className={styles.headingSection}>
                <h2 className={styles.heading}>You don’t need to be a writer — or have anyone waiting for it</h2>
                <p className={styles.description}>
                    {description}
                </p>
            </div>
            <div className={styles.stepsWrapper}>
                <div className={styles.optionCard}>
                    <span className={styles.stepBadge}>Step 1</span>
                    {STEP_OPTIONS.map((option, index) => (
                        <React.Fragment key={option.title}>
                            {index > 0 && (
                                <div className={styles.thenDivider}>
                                    <span className={styles.thenDividerLine} />
                                    <span>THEN</span>
                                    <span className={styles.thenDividerLine} />
                                </div>
                            )}
                            <div className={styles.optionRow}>
                                <div className={styles.iconBadge}>
                                    <Icon name={option.icon} className={styles.optionIcon} />
                                </div>
                                <div className={styles.optionContent}>
                                    <p className={styles.optionTitle}>{option.title}</p>
                                    <p className={styles.optionSubtitle}>{option.subtitle}</p>
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
                </div>
                <div className={styles.storyCardWrapper}>
                    <span className={styles.stepBadge}>Step 2</span>
                    <div className={styles.storyCard}>
                        <div className={styles.storyContent}>
                            <p className={styles.optionTitle}>It becomes a story</p>
                            <ul className={styles.storyBullets}>
                                {STORY_BULLETS.map(bullet => (
                                    <li key={bullet} className={styles.storyBullet}>{bullet}</li>
                                ))}
                            </ul>
                        </div>
                        <img src={tabletMemoirSrc} alt='' className={styles.storyImage} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export {
    ProductSlideContentV8
};
